// InvestmentLanding.js
import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import '../assets/InvestmentLanding.css';

function InvestmentLanding() {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        location: '',
        budget: '',
        profession: '',
        message: ''
    });
    const [captchaValue, setCaptchaValue] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const toggleForm = () => setShowForm(!showForm);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!captchaValue) {
            alert("Please verify you're not a robot.");
            return;
        }

        axios.post("https://www.samriddhidevelopers.in/backend/Invester.php", {
            ...formData,
            recaptcha: captchaValue
        })
            .then(res => {
                setFormSubmitted(true);
                setFormData({ name: '', email: '', phone: '', city: '', location: '', budget: '', profession: '', message: '' });
                setCaptchaValue(null);
                setTimeout(() => setFormSubmitted(false), 4000);
            })
            .catch(err => {
                console.error("Submission error:", err);
            });
    };

    return (
        <div className="investment-landing">
            <div className="landing-hero">
                <h1>
                    Land Investments Near Pune’s <br />
                    IT Hub – A Retreat for You, a Legacy for Tomorrow
                </h1>
                <p>
                    Nature-surrounded: legal-ready plots in Pune’s top growth zones – Now available.
                </p>
            </div>

            <div className="landing-section">
                <h2>Why Pune?</h2>
                <ul>
                    <li>✅ India’s booming IT and education hub</li>
                    <li>✅ Massive infrastructure expansion in Ring’s top growth zones – Now available for Bangalore-based investor</li>
                    <li>✅ Affordable land to 2X returns tomorrow</li>
                    <li>✅ Easier connectivity between Bangalore-to-Pune</li>
                </ul>
            </div>

            <div className="landing-section locations">
                <h2>Featured Locations:</h2>
                <div className="location-cols">
                    <div>
                        <h3>✔ Hinjewadi Phase 3</h3>
                        <ul>
                            <li>Close to India’s booming IT and education hub</li>
                            <li>Massive upcoming Ring Road</li>
                            <li>Gated plots with amenities</li>
                        </ul>

                        <h3>✔ Farmhouse/Resort Projects Around Pune</h3>
                        <ul>
                            <li>NA plots with luxury resort-style amenities</li>
                            <li>Income potential via homestay/rental model</li>
                            <li>Nearby forest reserves and rivers</li>
                        </ul>
                    </div>

                    <div>
                        <h3>✔ Panshet – Water Touch Scenic Plots</h3>
                        <ul>
                            <li>Backwater facing land</li>
                            <li>Ideal for weekend home</li>
                            <li>Tourist zone with high rental potential</li>
                            <li>Lifetime scenic value</li>
                        </ul>

                        <h3>Why Samriddhi Group?</h3>
                        <ul>
                            <li>1000+ satisfied investors from Mumbai, Pune, Bangalore</li>
                            <li>15 years in land development</li>
                            <li>Transparent documentation + Legal due diligence</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="cta-button">
                <button onClick={toggleForm}>Schedule a Pune Site Visit or Virtual Tour</button>
            </div>

            {showForm && (
                <div className="invest-form-overlay">
                    <div className="invest-form-container">
                        <span className="invest-close-btn" onClick={toggleForm}>×</span>
                        <h2>Book Your Site Visit</h2>
                        <form onSubmit={handleSubmit}>
                            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name*" required />
                            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number*" required />
                            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address*" required />
                            <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="Your City*" required />
                            <select name="location" value={formData.location} onChange={handleChange} required>
                                <option value="">Select Preferred Location*</option>
                                <option value="Hinjewadi">Near Hinjewadi Phase 3</option>
                                <option value="Panshet">Panshet Scenic Plots pune</option>
                                <option value="Farmhouse">Resort Farmhouse Plots Near Lonavala</option>
                            </select>
                            <select name="budget" value={formData.budget} onChange={handleChange} required>
                                <option value="">Approximate Budget*</option>
                                <option value="30 Lakhs">30 Lakhs</option>
                                <option value="50 Lakhs">50 Lakhs</option>
                                <option value="70 Lakhs">70 Lakhs</option>
                                <option value="1 Cr+">Above 1 Crore</option>
                            </select>
                            <input type="text" name="profession" value={formData.profession} onChange={handleChange} placeholder="Your Profession*" required />
                            <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Any special request or message..." rows="3"></textarea>
                            <ReCAPTCHA sitekey="6LeFlmArAAAAAG3OpN5TM6JZ6ZBq1p_mKUTCn85-" onChange={setCaptchaValue} />
                            <label className="consent">
                                <input type="checkbox" required /> I authorize contact from company representatives.
                            </label>
                            <button type="submit" className="invest-submit">Submit</button>
                            {formSubmitted && <p className="m-success-message">Thank you! Form submitted.</p>}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default InvestmentLanding;
